export default "__VITE_ASSET__BHfUslP4__"